import * as Yup from 'yup'
import { emailSchema } from './email.validation'
import { mobileSchema } from './mobile-schema.validation'

const accountProfileSchema = Yup.object().shape({
  image: Yup.object().shape({
    icon: Yup.string().trim(),
  }),
  account_holder: Yup.string()
    .nullable()
    .max(100, 'validation-account-holder-max')
    .required('validation-required'),
  email: emailSchema.nullable(true),
  contact_person: Yup.string().max(100, 'validation-contact-persion-max').nullable().notRequired(),
  phone: mobileSchema,
  description: Yup.string()
    // .max(30000, 'validation-description-max')
    .optional()
    .nullable(),
  address: Yup.string().max(200, 'validation-address-max').nullable().notRequired(),
  country: Yup.string().max(200, 'validation-country-max').nullable().nullable(),
  region: Yup.string().max(200, 'validation-region-min').nullable(),
  latitude: Yup.number().when('address', {
    is: (address: string) => !!address,
    then: Yup.number().required('validation-required'),
    otherwise: Yup.number().nullable().notRequired(),
  }),
  longitude: Yup.number().when('address', {
    is: (address: string) => !!address,
    then: Yup.number().required('validation-required'),
    otherwise: Yup.number().nullable().notRequired(),
  }),
  billing_email: emailSchema.nullable(true),
  gln: Yup.string()
    .matches(/^(?:\d{13})$/, 'validation-gln-regexp')
    .nullable(),
  website: Yup.string().nullable(true),
  media: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string().nullable(false).required('validation-required'),
      }),
    )
    .optional(),
})

export { accountProfileSchema }
